/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetSequencerDevicesRequest = {
  agentId: string;
};

/** @internal */
export type GetSequencerDevicesRequest$Outbound = {
  agent_id: string;
};

/** @internal */
export const GetSequencerDevicesRequest$outboundSchema: z.ZodType<
  GetSequencerDevicesRequest$Outbound,
  z.ZodTypeDef,
  GetSequencerDevicesRequest
> = z.object({
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function getSequencerDevicesRequestToJSON(
  getSequencerDevicesRequest: GetSequencerDevicesRequest,
): string {
  return JSON.stringify(
    GetSequencerDevicesRequest$outboundSchema.parse(getSequencerDevicesRequest),
  );
}
